export default "__VITE_ASSET__c34080fd__"